import { exposeRequireContext } from 'live/expose'

const req = require.context(
    './',
    true,
    /^(?!.*__tests__.*)^(?!.*\.stories\.*)^(?!.*Spec.js)^(?!.*worker.js)^(?!.*__mocks__.*\.js)((.*\.([t|j]sx?\.*))[^.]*$)/
)

// this call expose recursively all the modules on the current folder
exposeRequireContext(req, 'plugin-codaf/shared/')
